import { Comment } from "@/hooks/useComments";

// Simple in-memory store for comments on mock reviews
class MockCommentStore {
  private comments: Map<string, Comment[]> = new Map();
  private listeners: Array<() => void> = [];

  getComments(reviewId: string): Comment[] {
    return this.comments.get(reviewId) || [];
  }

  addComment(reviewId: string, comment: Comment): void {
    const existing = this.comments.get(reviewId) || [];
    this.comments.set(reviewId, [...existing, comment]);
    this.notifyListeners();
  }

  subscribe(listener: () => void): () => void {
    this.listeners.push(listener);
    
    // Return unsubscribe function
    return () => {
      const index = this.listeners.indexOf(listener);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  private notifyListeners(): void {
    this.listeners.forEach(listener => listener());
  }
}

export const mockCommentStore = new MockCommentStore();